import { render, staticRenderFns } from "./dismiss.vue?vue&type=template&id=3fbd31ed&scoped=true"
import script from "./dismiss.vue?vue&type=script&lang=js"
export * from "./dismiss.vue?vue&type=script&lang=js"
import style0 from "./dismiss.vue?vue&type=style&index=0&id=3fbd31ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbd31ed",
  null
  
)

export default component.exports